<template>
  <v-card class="mb-8">
    <v-card-title>
      自動延長設定
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-switch
            :input-value="enabled"
            label="新規卓の自動延長をデフォルトで有効にする"
            hide-details
            inset
            @change="$emit('update:enabled', $event)"
          />
        </v-col>
      </v-row>

      <v-row v-if="enabled">
        <v-col cols="12">
          <v-select
            :value="courseId"
            :items="courses"
            item-text="name"
            item-value="id"
            label="自動延長で使う延長コース"
            hint="未選択の場合は自動延長しません"
            persistent-hint
            clearable
            @change="$emit('update:course-id', $event)"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    enabled: {
      type: Boolean,
      default: false,
    },
    courseId: {
      type: [Number, String],
      default: null,
    },
    courses: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
